export default __webpack_public_path__ + "static/media/19thAnnualLectureMobile.2ec94bab.png";